import React from 'react'
import StartWithThese from './Startwiththese'
import TopComedy from './Top5comedy'
import ImageSlider from './BannerImage'
import '../AudioPage/components/Css/AudioMain.module.css'
import Footer from '../common/UI/Footer'
import NonFictionalData from './NonFictional'
import FictionalAudioBooks  from './Fictional'
import OverlayHome from '../Homepage/components/OverlayHome'

function AudioMain() {
  return (
    <>
          <OverlayHome type={"AudioBooks"} />

    <StartWithThese/>
    <TopComedy/>
    <NonFictionalData/>
    <FictionalAudioBooks/>
    <ImageSlider/>
    <Footer/>

    </>
  )
}

export default AudioMain